// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 265 ? "ed3608b8" : chunkId) + "." + {"234":"704b4c047311948b","265":"27d8431295746530"}[chunkId] + ".js";
};